import React from "react";
import classes from "./TopHeaderNavBar.scss";
import { ToddleIcon } from "SvgComponents";
import PropTypes from "prop-types";
import { ChevronLeftOutlined } from "@toddle-edu/ds-icons";
import { IconButton } from "@toddle-edu/ds-web";
import classNames from "classnames";

const styles = {
  removeBorderStyle: {
    border: "unset",
  },
};

const TopHeader = props => {
  const {
    testId,
    middleContainer,
    onBack,
    showMiddleContainer,
    showRightContainer,
    showToddleIcon,
    showLeftContainer,
    leftContainer,
    rightContainer,
    showBorder,
    showBackButton,
    headerText,
    containerStyle,
    subHeaderText,
    leftContainerStyle = {},
    middleContainerStyle = {},
    rightContainerStyle = {},
    leftContainerClass,
    backButtonSize,
    toddleIconHeight,
    toddleIconWidth,
    isCompactHeader = false,
  } = props;

  const subHeaderTextClass = classNames({
    ["text-body-2"]: true,
    [classes.subHeaderText]: true,
  });
  const leftContainerClasses = classNames(
    classes.leftContainer,
    leftContainerClass
  );

  const headerTextClass = classNames({
    [classes.headerText]: true,
  });

  const containerClasses = classNames({
    [classes.container]: true,
    [classes.compactContainer]: isCompactHeader,
  });

  return (
    <div
      className={containerClasses}
      style={
        !showBorder
          ? { ...styles.removeBorderStyle, ...containerStyle }
          : containerStyle
      }
    >
      <div className={leftContainerClasses} style={leftContainerStyle}>
        {showBackButton && (
          <div className={classes.backButtonWrapper}>
            {isCompactHeader ? (
              <IconButton
                icon={<ChevronLeftOutlined />}
                aria-label="Go back to the previous page"
                variant="neutral"
                size="medium"
                dsVersion="2.0"
                type="plain"
                testId={`${testId}-topHeaderNavBar-back`}
                onClick={onBack}
              ></IconButton>
            ) : (
              <IconButton
                icon={<ChevronLeftOutlined />}
                _legacy_variant="plain"
                aria-label="Go back to the previous page"
                variant="neutral"
                type="plain"
                size={backButtonSize}
                testId={`${testId}-topHeaderNavBar-back`}
                onClick={onBack}
              ></IconButton>
            )}

            {showToddleIcon && (
              <div className={classes.logo}>
                <ToddleIcon height={toddleIconHeight} width={toddleIconWidth} />
              </div>
            )}
          </div>
        )}
        {headerText && (
          <div className={classes.header}>
            <div className={headerTextClass}>{headerText}</div>
            {subHeaderText && (
              <div className={subHeaderTextClass}>{subHeaderText}</div>
            )}
          </div>
        )}
        {showLeftContainer && leftContainer}
      </div>

      {showMiddleContainer ? (
        <div className={classes.middleContainer} style={middleContainerStyle}>
          {middleContainer}
        </div>
      ) : null}

      {showRightContainer ? (
        <div className={classes.rightContainer} style={rightContainerStyle}>
          {rightContainer}
        </div>
      ) : null}
    </div>
  );
};
TopHeader.defaultProps = {
  testId: "appComponents",
  showMiddleContainer: false,
  showRightContainer: false,
  showBorder: true,
  showBackButton: true,
  showToddleIcon: true,
  showLeftContainer: false,
  middleContainerStyle: {},
  rightContainerStyle: {},
  leftContainerClass: "",
  backButtonSize: "small",
  toddleIconHeight: 32,
  toddleIconWidth: 32,
};
TopHeader.propTypes = {
  testId: PropTypes.string,
  middleContainer: PropTypes.element,
  onBack: PropTypes.func,
  showMiddleContainer: PropTypes.bool,
  showRightContainer: PropTypes.bool,
  showToddleIcon: PropTypes.bool,
  rightContainer: PropTypes.element,
  showBorder: PropTypes.bool,
  showBackButton: PropTypes.bool,
  headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  showLeftContainer: PropTypes.bool,
  leftContainer: PropTypes.element,
  middleContainerStyle: PropTypes.object,
  rightContainerStyle: PropTypes.object,
  leftContainerClass: PropTypes.string,
};
export default TopHeader;
